var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Lịch sử thay đổi phiếu thu",
        size: "lg",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "cancel-type": "danger",
        "use-panel": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "sk-panel mb-4" }, [
        _c("div", { staticClass: "sk-panel-head" }, [
          _c("div", { staticClass: "sk-panel-icon sk-panel-icon--warning" }, [
            _c("i", { staticClass: "el-icon-time" }),
          ]),
          _c("div", [
            _c("p", { staticClass: "sk-panel-title" }, [
              _vm._v("Phiếu thu: " + _vm._s(_vm.invoiceCode || "—")),
            ]),
            _c("p", { staticClass: "sk-panel-subtitle" }, [
              _vm._v("Học sinh: "),
              _c("strong", [_vm._v(_vm._s(_vm.studentName || "—"))]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "sk-table mb-4",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "empty-text": "Không có lịch sử thay đổi nào",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Thời gian", width: "160", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDateTime")(row.modifiedDate)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Người thao tác",
              prop: "modifiedByName",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(row.modifiedByName || "Hệ thống")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Hành động",
              prop: "actionLabel",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { size: "small", type: "info" } }, [
                      _vm._v(_vm._s(row.actionLabel || row.actionType)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tác vụ",
              width: "100",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "sk-table-link",
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewDetail(row)
                          },
                        },
                      },
                      [_vm._v("\n          Chi tiết\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.totalElements > 0
        ? _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page,
                  "page-size": _vm.size,
                  "page-sizes": [10, 20, 50],
                  layout: "sizes, prev, pager, next",
                  total: _vm.totalElements,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.page = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.page = $event
                  },
                  "update:pageSize": function ($event) {
                    _vm.size = $event
                  },
                  "update:page-size": function ($event) {
                    _vm.size = $event
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("invoice-audit-detail-dialog", { ref: "auditDetailDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }